import { h as c, r as h, c as b, S as m, f as l } from "./version-CCDoMjpz.js";
const y = async function(s, r, o) {
  return c(await h(f, s, r, o), s, r, o);
}, f = async function(s, r, o) {
  const t = await b(s, r, o), n = new URL(t.url), i = t.params;
  i instanceof Object && Object.keys(i).forEach((a) => n.searchParams.set(a, i[a]));
  const e = m.AbortController ? new AbortController() : null;
  function d() {
    e && !e.signal.aborted && e.abort();
  }
  t.abort && t.abort.addEventListener("abort", d);
  const u = t.timeout > 0 ? setTimeout(d, t.timeout) : null;
  return await fetch(n, {
    method: t.method,
    headers: Object.keys(t.headers).length > 0 ? new Headers(t.headers) : void 0,
    body: t.body,
    credentials: t.credentials,
    signal: e == null ? void 0 : e.signal,
    redirect: "follow"
  }).then(async (a) => ({
    url: n.toString(),
    method: t.method,
    status: a.status,
    statusText: a.statusText,
    headers: l([...a.headers.entries()]),
    body: t.method === "HEAD" ? "" : await a.text()
  })).catch((a) => ({
    url: n.toString(),
    method: t.method,
    status: -1,
    statusText: e != null && e.signal.aborted ? "Aborted" : "NetworkError",
    body: String(a),
    rawError: e != null && e.signal.aborted ? void 0 : a
  })).finally(() => {
    u !== null && clearTimeout(u), t.abort && t.abort.removeEventListener("abort", d);
  });
};
export {
  y as f
};
